import { createContext, ReactNode, useContext, useMemo, useState } from 'react'

interface IMockEnvContext {
  isMockEnvironment: boolean
  setMockEnvironment: React.Dispatch<React.SetStateAction<boolean>>
}

interface IProps {
  children: ReactNode
}

const MockEnvironmentContext = createContext<IMockEnvContext>(
  {} as IMockEnvContext,
)

const MockEnvironmentProvider = ({ children }: IProps) => {
  const [isMockEnvironment, setMockEnvironment] = useState(false)

  const value = useMemo(
    () => ({
      isMockEnvironment,
      setMockEnvironment,
    }),
    [isMockEnvironment],
  )

  return (
    <MockEnvironmentContext.Provider value={value}>
      {children}
    </MockEnvironmentContext.Provider>
  )
}

const useMockEnvironment = () => {
  const context = useContext(MockEnvironmentContext)

  if (!context) {
    throw new Error('useMock must be used within a MockContextProvider')
  }

  return context
}

export { MockEnvironmentProvider, useMockEnvironment }
